
export const APP_CONFIG = {
  // Stripe price configured for checkout sessions.
  // Keep this in the same mode (test/live) as your Firebase Stripe extension key.
  STRIPE_PRICE_ID: 'price_1SW9Ei6drXonnEUbRr0m7vAY',

  // APP CONSTANTS
  MAX_IMAGE_SIZE_PX: 800,
  JPEG_QUALITY: 0.7,
  DEBOUNCE_DELAY_MS: 800,
  DEFAULT_LOCATION: {
    lat: 40.7128,
    lng: -74.0060,
    name: "New York, NY"
  },
};
